const ICONS = {
  telegram: `${process.env.PUBLIC_URL}/images/messengers/telegram.svg`,
  max: `${process.env.PUBLIC_URL}/images/messengers/max-app.svg`,
};

export function TelegramBrandIcon({ className = "", size = 40, title = "Telegram" }) {
  return (
    <img
      src={ICONS.telegram}
      alt=""
      aria-hidden="true"
      title={title}
      className={className}
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
    />
  );
}

export function MaxBrandIcon({ className = "", size = 40, title = "MAX" }) {
  return (
    <img
      src={ICONS.max}
      alt=""
      aria-hidden="true"
      title={title}
      className={className}
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
    />
  );
}

/** Горизонтально: две иконки в ряд */
export function MessengerBrandInline({
  className = "",
  iconClassName = "",
  size = 24,
  spaced = false,
}) {
  return (
    <span
      className={`messenger-brand-inline${spaced ? " messenger-brand-inline--spaced" : ""}${className ? ` ${className}` : ""}`}
      aria-label="Telegram и MAX"
      role="img"
    >
      <TelegramBrandIcon
        className={`messenger-brand-inline__icon${iconClassName ? ` ${iconClassName}` : ""}`}
        size={size}
      />
      <MaxBrandIcon
        className={`messenger-brand-inline__icon${iconClassName ? ` ${iconClassName}` : ""}`}
        size={size}
      />
    </span>
  );
}

/** Вертикально: две иконки друг над другом */
export function MessengerBrandStack({
  className = "",
  iconClassName = "",
  size = 28,
}) {
  return (
    <span
      className={`messenger-brand-stack${className ? ` ${className}` : ""}`}
      aria-label="Telegram и MAX"
      role="img"
    >
      <TelegramBrandIcon
        className={`messenger-brand-stack__icon${iconClassName ? ` ${iconClassName}` : ""}`}
        size={size}
      />
      <MaxBrandIcon
        className={`messenger-brand-stack__icon${iconClassName ? ` ${iconClassName}` : ""}`}
        size={size}
      />
    </span>
  );
}

export default function MessengerBrandPair({
  className = "",
  iconClassName = "",
  size = 40,
  showLabels = false,
  labelClassName = "",
  variant = "default",
}) {
  const items = [
    { id: "telegram", label: "Telegram", Icon: TelegramBrandIcon },
    { id: "max", label: "MAX", Icon: MaxBrandIcon },
  ];

  return (
    <div
      className={`messenger-brand-pair messenger-brand-pair--${variant}${className ? ` ${className}` : ""}`}
      aria-label="Telegram и MAX"
    >
      {items.map(({ id, label, Icon }) => (
        <div className="messenger-brand-pair__item" key={id}>
          <Icon className={iconClassName} size={size} title={label} />
          {showLabels ? (
            <span className={`messenger-brand-pair__label${labelClassName ? ` ${labelClassName}` : ""}`}>
              {label}
            </span>
          ) : null}
        </div>
      ))}
    </div>
  );
}
